/**
 * Auto-detect backend URL based on where the app is running.
 *
 * - localhost / 127.0.0.1  →  local backend on port 4000
 * - any other host          →  same host (Nginx proxies /api/ → backend)
 *
 * No need to change .env when switching between local and production.
 */
const hostname = window.location.hostname;
const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';

// Use window.location.host (NOT hostname) so a non-standard port is kept —
// e.g. served on http://1.2.3.4:4005 the API stays on :4005 (Nginx there
// proxies /api/ → backend). For domains on 80/443 the port is omitted, so
// this is identical to the old hostname-only behaviour.
export const API_BASE = isLocal
  ? 'http://localhost:4010'
  : `${window.location.protocol}//${window.location.host}`;

export const API_URL = `${API_BASE}/api`;
